import { Directive, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core';

import { SgAuxRouteBridgeOutlet } from './models';
import { SgAuxRouteBridgeService } from './aux-route-bridge.service';

@Directive({
  selector: '[sgAuxRouteBridgeOutlet]',
  standalone: false,
})
export class SgAuxRouteBridgeOutletDirective implements SgAuxRouteBridgeOutlet, OnInit, OnDestroy {
  constructor(protected bridgeService: SgAuxRouteBridgeService) {}

  @Input('sgAuxRouteBridgeOutlet') name: string;
  @Input('outletContext') context?: string | string[];

  @Output() onDestroy = new EventEmitter<void>();

  get relativeRoot(): string[] {
    if (this.context) {
      return Array.isArray(this.context) ? this.context : [this.context];
    }
    return [];
  }

  ngOnInit(): void {
    this.bridgeService.registerOutlet(this);
  }

  ngOnDestroy(): void {
    this.onDestroy.next();
    this.onDestroy.complete();
  }
}
